<template>
  <main id="about-page">
    <ContentTitle
      :category="$t('sideMenu.Firmware')"
      :categoryIcon="'scf-traced'"
      :title="$t('sideMenu.CompaignAdd')"
    /><br /><br />
    <!-- <div class="title-style">
      <img src="../assets/icons/Diagnosys_v2.png" class="icon-title" />{{
        $t("sideMenu.Firmware")
      }}
      / {{ $t("sideMenu.CompaignAdd") }}
    </div> -->
    <div>
      <div class="bs-example">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 center-block text-center dinpro">
              {{ $t("pages.FirmwareCompaign.Filltheform") }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="dinpro700">
                {{ $t("pages.FirmwareCompaign.Description") }}
              </div>

              <div
                data-v-a1e2b94e=""
                id="Description"
                style="width: 100%; height: 35px"
                class="wj-control wj-content wj-dropdown wj-state-collapsed wj-combobox wj-state-focus wj-state-focused"
                tabindex="-1"
                _wjsiblingid="1"
              >
                <div class="wj-template">
                  <div class="wj-input">
                    <div class="wj-input-group wj-input-btn-visible">
                      <input
                        :disabled="!this.hasRole"
                        wj-part="input"
                        :placeholder="
                          $t('pages.FirmwareCompaign.Placeholder.Description')
                        "
                        @keyup="formatDescription"
                        v-model="TextDescription"
                        type="text"
                        class="wj-form-control"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                      />
                      <span
                        wj-part="btn"
                        class="wj-input-group-btn wj-state-disabled"
                        disabled="disabled"
                        style="display: none"
                      >
                        <button
                          class="wj-btn wj-btn-default"
                          tabindex="-1"
                          type="button"
                          aria-label="Toggle Dropdown"
                          disabled="disabled"
                        >
                          <span class="wj-glyph-down"></span>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="error" v-if="!TextDescription && hasNotSubmitted">
                {{ $t("pages.FirmwareCompaign.Validation.Description") }}
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 20px">
            <div class="col-md-6">
              <div class="dinpro700">
                {{ $t("pages.FirmwareCompaign.Manufacturer") }}
              </div>

              <wj-combo-box
                :disabled="!this.hasRole"
                id="comboManufacturer"
                :selectedIndexChanged="onManufacturerSelectedIndexChanged"
                :selectedValuePath="'id'"
                :displayMemberPath="'description'"
                :itemsSource="ManufacturersSource"
                :initialized="initManufacturers"
              ></wj-combo-box>
            </div>
            <div class="col-md-6">
              <div class="dinpro700">
                {{ $t("pages.FirmwareCompaign.Transmitter") }}
              </div>
              <div class="input-group mb-3">
                <input
                  :disabled="!this.hasRole"
                  wj-part="input"
                  v-on:change="handleBlur"
                  v-if="ManufacturerselectedCombo.selectedItem"
                  v-model="TransmitterValue"
                  @input="change($event)"
                  @change="change($event)"
                  type="text"
                  class="transmitterfield"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                />
                <span class="input-group-append">
                  <button class="btn btn-form-search" type="button">
                    <i class="scf-search" />
                  </button>
                </span>
              </div>
              <div class="error" v-if="!isValid">
                {{ $t("pages.FirmwareCompaign.Validation.Transmitter") }}
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 20px">
            <div class="col-md-6">
              <div class="dinpro700">
                {{ $t("pages.FirmwareCompaign.HardwareVersion") }}
              </div>

              <div
                data-v-a1e2b94e=""
                id="hardwareVersion"
                v-bind:style="{ 'background-color': disableBgColor }"
                style="width: 100%; height: 35px"
                class="wj-control wj-content wj-dropdown wj-state-collapsed wj-combobox wj-state-focus wj-state-focused"
                tabindex="-1"
                _wjsiblingid="1"
              >
                <div class="wj-template">
                  <div class="wj-input">
                    <div class="wj-input-group wj-input-btn-visible">
                      <input
                        wj-part="input"
                        :disabled="!isValid || disableBgColor == '#e3e3e3'"
                        @input="changeHardwareVersion($event)"
                        @change="changeHardwareVersion($event)"
                        v-on:change="handleBlurHardwareVersion"
                        v-model="currentHardwareVersion"
                        type="text"
                        class="wj-form-control"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                      />
                      <span
                        wj-part="btn"
                        class="wj-input-group-btn wj-state-disabled"
                        disabled="disabled"
                        style="display: none"
                      >
                        <button
                          class="wj-btn wj-btn-default"
                          tabindex="-1"
                          type="button"
                          aria-label="Toggle Dropdown"
                          disabled="disabled"
                        >
                          <span class="wj-glyph-down"></span>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="error"
                v-if="!isValidHardwareVersion && currentHardwareVersion"
              >
                {{ $t("pages.FirmwareCompaign.Validation.NotMatch") }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="dinpro700">
                {{ $t("pages.FirmwareCompaign.CurrentFirmwareVersion") }}
              </div>

              <div
                data-v-a1e2b94e=""
                id="CurrentFirmwareVersion"
                v-bind:style="{ 'background-color': disableBgColor }"
                style="width: 100%; height: 35px"
                class="wj-control wj-content wj-dropdown wj-state-collapsed wj-combobox wj-state-focus wj-state-focused"
                tabindex="-1"
                _wjsiblingid="1"
              >
                <div class="wj-template">
                  <div class="wj-input">
                    <div class="wj-input-group wj-input-btn-visible">
                      <input
                        wj-part="input"
                        :disabled="!isValid || disableBgColor == '#e3e3e3'"
                        @input="changeFirmwareCurrentVersion($event)"
                        @change="changeFirmwareCurrentVersion($event)"
                        v-on:change="handleBlurSoftwareVersion"
                        v-model="currentFirmwareVersion"
                        type="text"
                        class="wj-form-control"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                      />
                      <span
                        wj-part="btn"
                        class="wj-input-group-btn wj-state-disabled"
                        disabled="disabled"
                        style="display: none"
                      >
                        <button
                          class="wj-btn wj-btn-default"
                          tabindex="-1"
                          type="button"
                          aria-label="Toggle Dropdown"
                          disabled="disabled"
                        >
                          <span class="wj-glyph-down"></span>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="error"
                v-if="!isValidFirmwareCurrentVersion && currentFirmwareVersion"
              >
                {{ $t("pages.FirmwareCompaign.Validation.NotMatch") }}
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 20px">
            <div class="col-md-6">
              <!-- Downlink Channel -->
              <div class="dinpro700">
                {{ $t("pages.FirmwareCompaign.DownlinkChannel") }}
              </div>
              <wj-combo-box
                :disabled="!this.hasRole"
                id="comboDownlinkChannels"
                :itemsSource="DownlinkChannelsSource"
                :selectedValuePath="'value'"
                :displayMemberPath="'value'"
                :initialized="initDownlinkChannels"
                :selectedIndexChanged="onDownlinkChannelSelectedIndexChanged"
                :TextChanged="onDownlinkChannelTextChanged"
              >
              </wj-combo-box>
            </div>
            <div class="col-md-6">
              <!-- Downlink Modulation -->
              <div class="dinpro700">
                {{ $t("pages.FirmwareCompaign.DownlinkModulation") }}
              </div>
              <wj-combo-box
                :disabled="!this.hasRole"
                id="comboDownlinkModulations"
                :itemsSource="DownlinkModulationsSource"
                :initialized="initDownlinkModulations"
                :selectedValuePath="'value'"
                :displayMemberPath="'value'"
                :selectedIndexChanged="
                  onDownlinkModulationsSelectedIndexChanged
                "
                :TextChanged="onDownlinkModulationTextChanged"
              >
              </wj-combo-box>
            </div>
          </div>
          <div class="row" style="margin-top: 20px">
            <div class="col-md-6">
              <!-- End Date -->
              <div class="dinpro700">
                {{ $t("pages.FirmwareCompaign.EndDate") }}
              </div>
              <wj-input-date
                :disabled="!this.hasRole"
                id="theDate"
                :initialized="initDate"
                :format="'dd/MM/yyyy'"
                :min="firstDay"
              ></wj-input-date>
            </div>
            <div class="col-md-6">
              <!-- Target Firmware Version -->
              <div class="dinpro700">
                {{ $t("pages.FirmwareCompaign.TargetFirmwareVersion") }}
              </div>

              <wj-combo-box
                id="comboTargetFirmwareVersion"
                :itemsSource="TargetFirmwareVersionsSource"
                :initialized="initTargetFirmwareVersions"
                :selectedIndexChanged="
                  onTargetFirmwareVersionSelectedIndexChanged
                "
                :selectedValuePath="'Id'"
                :displayMemberPath="'firmwareVersion'"
                v-bind:style="{
                  'background-color': TargetFirmwareVersionbgColor,
                }"
                :disabled="
                  !isValidHardwareVersion || !isValidFirmwareCurrentVersion
                "
              >
              </wj-combo-box>
              <div
                class="error"
                v-if="
                  !TargetFirmwareVersionsSourceNotEmty &&
                  isValidHardwareVersion &&
                  isValidFirmwareCurrentVersion &&
                  TargetFirmwareVersionbgColor == 'white'
                "
              >
                {{
                  $t("pages.FirmwareCompaign.Validation.TargetFirmwareVersion")
                }}
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 20px">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
              <button
                id="Save"
                type="button"
                class="btn btn-success"
                v-bind:style="
                  !TargetFirmwareVersionsSourceNotEmty ||
                  !isValidHardwareVersion ||
                  !isValidFirmwareCurrentVersion
                    ? { 'background-color': 'gray!important' }
                    : ''
                "
                @click.prevent="SendCompaign"
                :disabled="
                  (!TargetFirmwareVersionsSourceNotEmty ||
                    !isValidHardwareVersion ||
                    !isValidFirmwareCurrentVersion) &&
                  !active
                "
              >
                {{ $t("common.save") }}
              </button>
              <button
                id="Reset"
                type="button"
                class="btn btn-warning ml-2"
                @click.prevent="cancel"
              >
                {{ $t("pages.FirmwareAdd.Reset") }}
              </button>
            </div>
          </div>

          <div class="row" style="margin-top: 20px">
            <div class="col-md-12">
              <p class="alert alert-success" role="alert" v-if="ShowMessage">
                {{ $t("pages.FirmwareCompaign.Axios.Success") }}
              </p>
            </div>
          </div>
          <div class="row" style="margin-top: 20px">
            <div class="col-md-12">
              <p
                class="alert alert-danger"
                role="alert"
                v-if="!SuccesSend && ErrorSend"
              >
                {{ $t("pages.FirmwareCompaign.Axios.Fail") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loaderSpinner :loading="isLoading"></loaderSpinner>
  </main>
</template>

<script>
import { defineComponent } from "vue";
import Configs from "../../configs";
import MainService from "../services/MainService";
import "@grapecity/wijmo.styles/wijmo.css";
import LoaderSpinner from "../components/LoadingSpinner.vue";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
import "@grapecity/wijmo.vue2.core";
import * as wijmo from "@grapecity/wijmo";
import { WjInputDate, WjComboBox } from "@grapecity/wijmo.vue2.input";
const CampaignMinimumDurationInDays = Configs.value(
  "VUE_APP_CAMPAIGN_MINIMUM_DURATION_INDAYS"
);
export default defineComponent({
  name: "CompaignAdd",
  components: {
    LoaderSpinner,
    WjComboBox,
    WjInputDate,
    ContentTitle,
  },
 
  watch: {
    currentScope: {
        handler: function(newVal) {
          if (newVal) {
            this.mainService = new MainService(this.$jwt.token, newVal);
            this.initComponentData();
            this.componentKey += 1;
          }
        },
        deep: true
      },
      accessToken(newVal) {
        if (newVal) {
          this.mainService = new MainService(newVal, this.currentScope);
        }
      },
  },
  data() {
    return {
      componentKey: 0,
      firstDay: new Date(
        new Date().setDate(
          new Date().getDate() -
            new Date().getDay() +
            parseInt(CampaignMinimumDurationInDays)
        )
      ),
      hasRole: this.$jwt.hasAtLeastOneRole([
        "dm-administrator",
        "dm-ufw-write",
      ]),
      InitValueManufacturer: null,
      mainService: new MainService(this.$jwt.token, this.$jwt.scope),
      ErrorSend: false,
      SuccesSend: false,
      hasNotSubmitted: false,
      active: false,
      starterDate: null,
      disableBgColor: "#e3e3e3",
      TargetFirmwareVersionbgColor: "white",
      TargetFirmwareVersionsSourceNotEmty: false,
      isLoading: false,
      TextDescription: "",
      DownlinkChannelselectedValue: "",
      DownlinkChanneltext: "",
      DownlinkModulationselectedValue: "",
      DownlinkModulationtext: "",
      ManufacturerselectedCombo: {},
      DownlinkChannelselectedCombo: {},
      DownlinkModulationselectedCombo: {},
      Manufacturertext: "",
      TransmitterValue: "",
      DownlinkChannelsSource: null,
      DownlinkModulationsSource: null,
      TargetFirmwareVersionsSource: null,
      TargetFirmwareVersionsSelectedValue: "",
      TargetFirmwareVersiontext: "",
      ManufacturersSource: null,
      ShowMessage: false,
      theDate: {},
      fixedDate: new Date("2022-03-08"),
      currentFirmwareVersion: "",
      currentHardwareVersion: "",
      hexadecimalManufacturerIdentifier: "",
      FirmwareCampaign: {
        Id: 0,
        ExternalId: null,
        ManufacturerId: 1,
        DownlinkChannelEnum: 2,
        DownlinkModulationEnum: "HSPEED",
        // ModulationEnumnelEnum: "LD2400",
        CampaingEndDate: new Date("2022-03-08"),
        TransmitterFirmwareId: 3,
        StatusEnum: null,
        FailureErrorDetail: null,
        Description: this.TextDescription,
        Manufacturer: null,
        TransmitterFirmware: null,
        FirmwareCampaignTransmitters: [
          {
            Id: 0,
            ExternalId: null,
            FirmwareCampaignId: 6,
            DeviceId: 0,
            HardwareVersion: "",
            CurrentFirmwareVersion: "",
          },
        ],
        DeviceId: null,
      },
      mynumber: "",
      isValid: false,
      regex: /^((0CAE|4E73|2333)[0-9afA-F]{10,10}(03|07|21))$/,
      regexITW: /^((2697)[0-9afA-F]{10,10}(03|07|21))$/,
      regexDME: /^((11A5)[0-9afA-F]{10,10}(03|07|21))$/,
      regexSEN: /^((4CAE)[0-9afA-F]{10,10}(03|07|21))$/,
      regexHexa: /^[0-9A-Fa-f]{1,}[.][0-9A-Fa-f]{1,}$/,
      isValidHardwareVersion: false,
      isValidFirmwareCurrentVersion: false,
    };
  },
  methods: {
    changeHardwareVersion: function (e) {
      this.TargetFirmwareVersionsSource = [];
      this.TargetFirmwareVersionsSelectedValue = "";
      this.TargetFirmwareVersionsSourceNotEmty = false;
      const number = e.target.value;
      this.isHexValidHardwareVersion(number);
    },
    changeFirmwareCurrentVersion: function (e) {
      this.TargetFirmwareVersionsSource = [];
      this.TargetFirmwareVersionsSelectedValue = "";
      this.TargetFirmwareVersionsSourceNotEmty = false;
      const number = e.target.value;
      this.isHexValidFirmwareCurrentVersion(number);
    },
    change: function (e) {
      const number = e.target.value;
      this.isNumberValid(number);
    },
    isNumberValid: function (inputNumber) {
      console.log(inputNumber);

      if (this.ManufacturerselectedCombo.selectedItem.externalId == "DME") {
        this.isValid = this.regexDME.test(inputNumber);
      } else if (
        this.ManufacturerselectedCombo.selectedItem.externalId == "SEN"
      ) {
        this.isValid = this.regexSEN.test(inputNumber);
      } else if (
        this.ManufacturerselectedCombo.selectedItem.externalId == "ITW"
      ) {
        this.isValid = this.regexITW.test(inputNumber);
      }

      //  this.isValid=   this.regex.test(inputNumber) 11A5000404371907
      if (this.isValid) {
        this.disableBgColor = "white";
        this.ShowMessage = false;
      } else {
        this.TargetFirmwareVersionbgColor = "#e3e3e3";
        this.disableBgColor = "#e3e3e3";
        this.initCurrentHardwareVersion();
        this.initCurrentFirmwareVersion();
        this.TargetFirmwareVersionsSource = [];
        this.TargetFirmwareVersionsSelectedValue = "";
        this.TargetFirmwareVersionsSourceNotEmty = false;

        this.SuccesSend = false;
      }
    },
    isHexValidFirmwareCurrentVersion: function (h) {
      this.isValidFirmwareCurrentVersion = this.regexHexa.test(h);
      if (this.isValidFirmwareCurrentVersion) {
        return true;
      } else {
        this.TargetFirmwareVersionbgColor = "#e3e3e3";

        this.SuccesSend = false;
      }
      return false;
    },
    isHexValidHardwareVersion: function (h) {
      this.isValidHardwareVersion = this.regexHexa.test(h);
      if (this.isValidHardwareVersion) {
        return true;
      } else {
        this.TargetFirmwareVersionbgColor = "#e3e3e3";

        this.SuccesSend = false;
      }
      return false;
    },

    initComboNoSrc: function (combo) {
      this.TransmitterValue = combo.text;
    },
    onTextChanged: function (s) {
      console.log(s.text);
      this.TransmitterValue = s.text;
    },
    isHardwareAndFirmwareNotEmpty() {
      if (this.currentFirmwareVersion && this.currentHardwareVersion) {
        this.TargetFirmwareVersionbgColor = "white";
        return true;
      } else {
        this.TargetFirmwareVersionbgColor = "#e3e3e3";
        return false;
      }
    },

    initDate: function (date) {
      var today = new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() + 10)
      );
      date.value = today.toISOString().substr(0, 10);

      this.theDate = date;
      this.starterDate = date;
    },

    initDownlinkChannels: function (combo) {
      this.DownlinkChannelselectedCombo = combo;
      this.DownlinkChannelselectedValue = combo.selectedValue;
    },
    onDownlinkChannelTextChanged: function (s) {
      this.DownlinkChanneltext = s.text;
    },
    onDownlinkChannelSelectedIndexChanged: function (s) {
      this.DownlinkChannelselectedCombo = s;
      this.DownlinkChannelselectedValue = s.selectedValue;
    },
    /*  Downlink Modulations */
    initDownlinkModulations: function (combo) {
      this.DownlinkModulationselectedCombo = combo;
      this.DownlinkModulationselectedValue = combo.selectedValue;
    },
    onDownlinkModulationTextChanged: function (s) {
      this.DownlinkModulationtext = s.text;
    },
    onDownlinkModulationsSelectedIndexChanged: function (s) {
      this.DownlinkModulationselectedCombo = s;
      this.DownlinkModulationselectedValue = s.selectedValue;
    },
    /*  Manufacturer */
    initManufacturers: function (combo) {
      this.ManufacturerselectedCombo = combo;
    },
    initCurrentHardwareVersion() {
      this.currentHardwareVersion = "";
    },
    initCurrentFirmwareVersion() {
      this.currentFirmwareVersion = "";
    },
    // onManufacturerTextChanged: function (s) {
    //   this.Manufacturertext = s.text;
    // },
    onManufacturerSelectedIndexChanged: function (s) {
      console.log(s.selectedValue);
      console.log(s.selectedItem.hexadecimalManufacturerIdentifier);
      this.hexadecimalManufacturerIdentifier =
        s.selectedItem.hexadecimalManufacturerIdentifier;
      this.TransmitterValue = s.selectedItem.hexadecimalManufacturerIdentifier;
      this.ManufacturerselectedCombo = s;
      this.initCurrentHardwareVersion();
      this.initCurrentFirmwareVersion();
      this.TargetFirmwareVersionsSourceNotEmty = false;
      this.TargetFirmwareVersionsSource = [];
      this.TargetFirmwareVersionsSelectedValue = "";
      this.isNumberValid(this.TransmitterValue);
      this.TargetFirmwareVersionbgColor = "#e3e3e3";
      this.SuccesSend = false;
    },

    async getTransmitterDeviceData(identifier) {
      // return await this.mainService.getTransmitterDevice(identifier).then((t) => {
      //   return t;
      // });

      return await this.mainService
        .getEquipmentDetails("Transmitter", identifier)
        .then((t) => {
          return t;
        });
    },
    async geTargetFirmwareVersionsData(hardware, firmware) {
      return await this.mainService
        .GetTargetFirmwareVersions(hardware, firmware)
        .then((t) => {
          return t;
        });
    },
    async handleBlur(e) {
      if (this.isValid) {
        this.isLoading = true;
        let transmitterdeviceinfo = await this.getTransmitterDeviceData(
          e.target.value
        ).finally(() => {
          setTimeout(() => {
            this.isLoading = false;
          }, 200);
        });

        if (
          typeof transmitterdeviceinfo != "undefined" &&
          transmitterdeviceinfo != null
        ) {
          var alldevices = await this.mainService.getdevices();
          var device = alldevices.filter((d) => d.ExternalId == e.target.value);

          //TODO sould be optimized..
          this.DeviceId = device != null ? device[0].Id : null;
          this.currentFirmwareVersion = transmitterdeviceinfo.FirmwareVersion;
          this.currentHardwareVersion = transmitterdeviceinfo.HardwareVersion;
          this.isHexValidFirmwareCurrentVersion(this.currentFirmwareVersion);
          this.isHexValidHardwareVersion(this.currentHardwareVersion);

          if (
            typeof this.currentFirmwareVersion != "undefined" &&
            typeof this.currentHardwareVersion != "undefined"
          ) {
            this.disableBgColor = "#e3e3e3";
          } else {
            this.disableBgColor = "white";
          }

          this.isLoading = true;
          this.TargetFirmwareVersionsSource =
            await this.geTargetFirmwareVersionsData(
              this.currentHardwareVersion,
              this.currentFirmwareVersion
            ).finally(() => {
              setTimeout(() => {
                this.isLoading = false;
              }, 200);
            });

          if (this.TargetFirmwareVersionsSource.length < 1) {
            if (
              typeof this.currentFirmwareVersion != "undefined" &&
              typeof this.currentHardwareVersion != "undefined"
            ) {
              this.TargetFirmwareVersionbgColor = "white";
            } else {
              this.TargetFirmwareVersionbgColor = "#e3e3e3";
            }

            this.TargetFirmwareVersionsSourceNotEmty = false;
          } else {
            this.TargetFirmwareVersionsSourceNotEmty = true;

            this.TargetFirmwareVersionbgColor = "white";
          }
          console.log(
            "TargetFirmwareVersionsSource : " +
              this.TargetFirmwareVersionsSource
          );
        } else {
          this.disableBgColor = "white";
          this.DeviceId = null;
          this.TargetFirmwareVersionsSourceNotEmty = false;
          this.initCurrentHardwareVersion();
          this.initCurrentFirmwareVersion();
          this.SuccesSend = false;
          this.TargetFirmwareVersionsSource = [];
          console.log("empty");
        }
      } // END if isvalid
    },
    async handleBlurHardwareVersion(e) {
      console.log(e.target.value);

      if (
        this.isHexValidFirmwareCurrentVersion(this.currentFirmwareVersion) &&
        this.isHexValidHardwareVersion(e.target.value)
      ) {
        this.isLoading = true;
        this.TargetFirmwareVersionsSource =
          await this.geTargetFirmwareVersionsData(
            e.target.value,
            this.currentFirmwareVersion
          ).finally(() => {
            setTimeout(() => {
              this.isLoading = false;
            }, 200);
          });
        if (this.TargetFirmwareVersionsSource.length < 1) {
          this.TargetFirmwareVersionbgColor = "white";
          this.TargetFirmwareVersionsSourceNotEmty = false;
        } else {
          this.TargetFirmwareVersionsSourceNotEmty = true;
          this.TargetFirmwareVersionbgColor = "white";
        }
        console.log(
          "TargetFirmwareVersionsSource : " + this.TargetFirmwareVersionsSource
        );

        console.log("currentFirmwareVersion [Not Empty]");
      } else {
        console.log("currentFirmwareVersion [Empty]");
        this.TargetFirmwareVersionsSourceNotEmty = false;
        this.TargetFirmwareVersionsSource = [];
        this.TargetFirmwareVersionbgColor = "#e3e3e3";
      }
    },
    async handleBlurSoftwareVersion(e) {
      console.log(e.target.value);
      if (
        this.isHexValidHardwareVersion(this.currentHardwareVersion) &&
        this.isHexValidFirmwareCurrentVersion(e.target.value)
      ) {
        console.log("currentHardwareVersion [Not Empty]");
        this.isLoading = true;
        this.TargetFirmwareVersionsSource =
          await this.geTargetFirmwareVersionsData(
            this.currentHardwareVersion,
            e.target.value
          ).finally(() => {
            setTimeout(() => {
              this.isLoading = false;
            }, 200);
          });
        if (this.TargetFirmwareVersionsSource.length < 1) {
          this.TargetFirmwareVersionbgColor = "white";
          this.TargetFirmwareVersionsSourceNotEmty = false;
        } else {
          this.TargetFirmwareVersionbgColor = "white";
          this.TargetFirmwareVersionsSourceNotEmty = true;
        }
        console.log(
          "TargetFirmwareVersionsSource : " + this.TargetFirmwareVersionsSource
        );
      } else {
        //  this.TargetFirmwareVersionsSourceNotEmty = false;
        console.log("currentHardwareVersion [Empty]");
        this.TargetFirmwareVersionsSourceNotEmty = false;
        this.TargetFirmwareVersionsSource = [];
        this.TargetFirmwareVersionbgColor = "#e3e3e3";
      }
    },
    capitalizeFirstLetter(value) {
      // Do formatting...
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatDescription() {
      this.TextDescription = this.capitalizeFirstLetter(this.TextDescription);
    },
    initTargetFirmwareVersions: function (combo) {
      this.TargetFirmwareVersionsSelectedValue = combo;
    },
    onTargetFirmwareVersionSelectedIndexChanged: function (s) {
      this.TargetFirmwareVersionsSelectedValue = s;
    },
    cancel() {
      this.active = false;
      this.DownlinkModulationselectedCombo.selectedValue = "WM2400";
      this.DownlinkChannelselectedCombo.selectedValue = 120;
      this.ManufacturerselectedCombo.selectedValue = 1;
      this.theDate.value = new Date(
        new Date().setDate(new Date().getDate() - new Date().getDay() + 10)
      )
        .toISOString()
        .substr(0, 10);

      this.ShowMessage = false;
      this.TransmitterValue = this.hexadecimalManufacturerIdentifier;
      (this.TextDescription = ""), (this.hasNotSubmitted = false); //Description
      this.SuccesSend = false;
      // this.ErrorSend = false;
      this.TargetFirmwareVersionsSource = [];
      this.TargetFirmwareVersionsSourceNotEmty = false;

      this.TargetFirmwareVersionbgColor = "#e3e3e3";
      this.isNumberValid(this.TransmitterValue);
    },
    padTo2Digits: function (num) {
      return num.toString().padStart(2, "0");
    },

    formatDate: function (d) {
      return [
        this.padTo2Digits(d.getDate()),
        this.padTo2Digits(d.getMonth() + 1),
        d.getFullYear(),
      ].join("/");
    },
    SendCompaign() {
      if (this.TextDescription) {
        this.FirmwareCampaign.Description = this.TextDescription;
        this.FirmwareCampaign.ManufacturerId =
          this.ManufacturerselectedCombo.selectedItem.id;
        this.FirmwareCampaign.DownlinkChannelEnum =
          this.DownlinkChannelselectedValue;
        this.FirmwareCampaign.DownlinkModulationEnum =
          this.DownlinkModulationselectedValue;

        this.FirmwareCampaign.CampaingEndDate = this.theDate.value;
        this.FirmwareCampaign.TransmitterFirmwareId =
          this.TargetFirmwareVersionsSelectedValue.selectedItem.Id; //  12 ; //à recuperer lors de la recherche de transmitterdevice

        console.log(this.TargetFirmwareVersionsSelectedValue.selectedItem.id);
        this.FirmwareCampaign.FirmwareCampaignTransmitters[0].ExternalId =
          this.TransmitterValue;
        this.FirmwareCampaign.FirmwareCampaignTransmitters[0].DeviceId =
          this.DeviceId;
        this.FirmwareCampaign.FirmwareCampaignTransmitters[0].HardwareVersion =
          this.currentHardwareVersion;
        this.FirmwareCampaign.FirmwareCampaignTransmitters[0].CurrentFirmwareVersion =
          this.currentFirmwareVersion;

        this.isLoading = true;
        this.mainService
          .SendCompaign(this.FirmwareCampaign)
          .then((response) => {
            //  console.log(response);
            console.log(response);
            //Votre demande de Descente de Firmware est envoyée
            this.SuccesSend = true;
            //this.ErrorSend = false;
            //  this.active=false;
            this.ShowMessage = true;
            this.TransmitterValue = this.hexadecimalManufacturerIdentifier;
            this.TextDescription = "";
            //   this.TargetFirmwareVersionsSource = [];
            // this.TargetFirmwareVersionsSelectedValue = "";
            // this.TargetFirmwareVersionsSourceNotEmty = false;

            // this.TargetFirmwareVersionsSource = [];
            // this.TargetFirmwareVersionsSelectedValue = "";
            // this.TargetFirmwareVersionsSourceNotEmty = false;

            //   this.TargetFirmwareVersionsSource = [];
            //  // this.TargetFirmwareVersionsSourceNotEmty = false;
            //   this.TargetFirmwareVersionbgColor = "#e3e3e3";
            this.isNumberValid(this.TransmitterValue);
          })
          .catch((error) => {
            console.log(error);

            //this.ErrorSend = true;
            this.SuccesSend = false;
          })
          .finally(() => {
            this.hasNotSubmitted = false;
            setTimeout(() => {
              this.isLoading = false;
            }, 200);
          });
      } else {
        this.hasNotSubmitted = true;
      } //end if textdesciption
    },
    loadCulture(culture) {
      // apply new culture to page
      let url = `https://cdn.grapecity.com/wijmo/5.latest/controls/cultures/wijmo.culture.${culture}.js`,
        scripts = document.getElementsByTagName("script");

      for (let i = 0; i < scripts.length; i++) {
        let script = scripts[i];
        if (script.src.indexOf("/cultures/wijmo.culture.") > -1) {
          script.parentElement.removeChild(script);
          break;
        }
      }

      let script = document.createElement("script");
      script.onload = () => {
        this.$forceUpdate();
        // invalidate all Wijmo controls to accept new culture
        wijmo.Control.invalidateAll();
      };
      script.src = url;
      document.head.appendChild(script);
    },
    
    async initComponentData() {
      this.ManufacturersSource = await this.mainService.getManufacturers();
      this.DownlinkChannelsSource = this.mainService.getDownlinkChannels();
      this.DownlinkModulationsSource =
        this.mainService.getDownlinkModulations();
    },
  },
  created() {
      if (this.currentScope != null && this.currentScope.value != null) {
        this.initComponentData();
        this.componentKey++;
      }
  },
  beforeMount() {
    this.loadCulture("fr");
  },
  filters: {
    formatDateTime: function (value) {
      return wijmo.Globalize.format(value, "dd/MM/yyyy");
    },
  },
});
</script>

<style scoped lang="scss">
.wj-control .wj-template,
.wj-control .wj-input {
  height: 100%;
  height: 27px !important;
}

.tmp {
  display: table-cell;
  padding: 4px 8px;
  border: 0;
  width: 100%;
  height: 100%;
  color: inherit;
  background: 0 0;
  min-height: 2em;
}

.transmitterfield {
  // border-radius: 4px;
  // border: 1.5px solid rgb(0 0 0 / 95%) !important;
  border-radius: 4px;
  border: 1.5px solid #030f40 !important;
  width: 100%;
  height: 36px;

  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.btn-form-search {
  color: #6c757d;
  border-color: #6c757d;
  height: 36px;
}

.dinpro {
  font-family: "D-DIN-900";
  font-style: normal;
  font-size: 18px;
  color: #030f40;
  line-height: 24px;
}

.dinpro700 {
  font-family: "D-DIN-700";
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: #030f40;
  padding-bottom: 5px;
}

// @import "~bootstrap/dist/css/bootstrap.min";
@import "../../node_modules/@grapecity/wijmo.styles/wijmo.css";
</style>
//TODO refactor css content (should using variables - scss)
<style scoped src="../assets/css/campaignAdd.css"></style>
